import { Component, Prop, Watch, Vue } from 'vue-property-decorator';

import Loader from '../loader';

@Component({
    data() {
        return {
            opened: false
        };
    },
    components: {
        Loader
    }
})
export default class LoaderModal extends Vue {
    @Prop(Boolean)
    value: boolean;

    opened: boolean;

    mounted() {
        this.opened = this.value;
    }

    @Watch('value')
    onChangeValue(value) {
        this.opened = value;
    }

    @Watch('opened')
    onChangeOpened(value) {
        this.$emit('input', value);
    }
}
